module.exports = __webpack_public_path__ + "static/hoivakotilive_slide_3-933fdcbabcae340e443987b3c334944c.jpg";